








































































































import Component from 'vue-class-component'
import Modal from '@/components/Modal.vue'
import { EUserPermissions, IResidentContact } from '@zunta/configurations'
import Icon from '@/components/Icon.vue'
import Switcher from '@/components/Switcher.vue'
import { User } from '@/classes/User'
import Api from '@/api'
import SharedFunctions from '@/views/app/management/review-statements/SharedFunctions'
import ScrollView from '@/components/ScrollView.vue'
import { ERecipientType } from '@zunta/configurations/dist/types/resident'
import { formatResidentAddress, formatTypesOfContact } from '@/utils/helpers'

@Component({
  props: {
    residentId: {
      type: [String, Number],
      require: true
    }
  },
  components: {
    ScrollView,
    Switcher,
    Icon,
    Modal
  }
})
export default class ChangeMailContactModal extends SharedFunctions {
  user: User = Api.getUser() as User
  EUserPermissions: any = EUserPermissions
  deliverToRoom: boolean | null = false
  addressesList: any [] = []

  setDeliverToRoom (value: any) {
    if (this.checkPermissions()) {
      this.deliverToRoom = value
    }
  }

  close () {
    this.$emit('close')
  }

  save () {
    const payload = {
      deliverToRoom: this.deliverToRoom,
      batchId: this.batchID,
      contacts: this.addressesList.map((item: IResidentContact) => {
        return {
          id: item.id,
          isAddressUsedForMailing: item.isAddressUsedForMailing,
          isEmailUsedForMailing: item.isEmailUsedForMailing
        }
      })
    }
    this.$emit('save', payload)
  }

  isAddressValid (contact: IResidentContact) {
    return contact.zipCode && /^\d{5}(?:[-\s]\d{4})?$/.test(contact.zipCode) &&
      contact.state &&
      contact.city &&
      contact.addressLine1
  }

  isEmailValid (contact: IResidentContact) {
    return contact.email && /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/i.test(contact.email)
  }

  isAnyFieldOfAddress (contact: IResidentContact) {
    return contact.city ||
      contact.state ||
      contact.zipCode ||
      contact.addressLine2 ||
      contact.addressLine1 ||
      contact.addressLine3
  }

  checkPermissions () {
    if (!this.user.hasPermissionFor(EUserPermissions.EDIT_CONTACT_SETTINGS) && !this.user.isResident()) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Permission Denied',
        header: `Modify Contact Settings`,
        icon: 'warning'
      })
      return false
    }
    return true
  }

  setUpdatedAddressesList (contact: IResidentContact, key: string, value: boolean) {
    if (this.checkPermissions()) {
      // @ts-ignore
      contact[key] = value
    }
  }

  contactAddress (contact: IResidentContact) {
    return formatResidentAddress(contact)
  }

  formatTypesOfContact (contact: IResidentContact) {
    return formatTypesOfContact(contact)
  }

  mounted () {
    this.residentModuleInstance.fetchResidentContacts(this.$props.residentId)

    this.$watch('residentContacts', (value) => {
      const batchStatements = this.batchStatements
      this.addressesList = JSON.parse(JSON.stringify(value)).map((c: IResidentContact) => {
        const statement = batchStatements.find((s: any) => {
          if (!s.recipient) {
            return false
          }
          if (s.recipient.type === ERecipientType.ROOM || !s.recipient.mailContact) {
            return false
          }
          return s.recipient.mailContact.id === c.id
        })
        if (!statement) {
          c.isAddressUsedForMailing = false
          c.isEmailUsedForMailing = false
          return c
        }
        if (statement.recipient.type === ERecipientType.EMAIL) {
          c.isEmailUsedForMailing = true
        }
        if (statement.recipient.type === ERecipientType.MAIL) {
          c.isAddressUsedForMailing = true
        }
        return c
      })
    }, { deep: true, immediate: true })

    this.$watch('resident', (value) => {
      const statement = this.batchStatements.find((s: any) => {
        return s.recipient && s.recipient.type === ERecipientType.ROOM
      })
      this.deliverToRoom = !!statement
    }, { deep: true, immediate: true })
  }
}
